import React from "react";
import { JT, VT, BT } from "../../helpers/constants/circuitCodes";
import {
  START_DATE,
  VENUE,
  HOST_NATION,
  PRIZE_MONEY
} from "../WhatsOnTable/types";

import { SortCriteria } from "../WhatsOnHero/types";

interface TableProps {
  items?: any[];
  className?: string;
  tourCode: string;
  setSortCriteria: (criteria: SortCriteria) => void;
  sortCriteria: SortCriteria;
}

interface TournamentProps {
  tourStatusCode: string;
  isRecognised: string;
  tournamentLink: string;
  tournamentName: string;
  recognisedTournamentLink: string;
  hostNationCode: string;
  hostNation: string;
  tourStatusDesc: string;
  liveStreamingUrl: string;
  liveLink: string;
  dates: string;
  location: string;
  category: string;
  prizeMoney: string;
  indoorOrOutDoor: string;
  surfaceDesc: string;
}

const Status = ({ code }: any) => {
  switch (code) {
    case "CN":
      return (
        <span className="status">
          <div className="cancelled">Cancelled</div>
        </span>
      );
      break;
    case "PP":
      return (
        <span className="status">
          <div className="postponed">Postponed</div>
        </span>
      );
      break;
    default:
      return <span className="status" />;
  }
};

const Table = ({
  items = [],
  className,
  tourCode,
  setSortCriteria,
  sortCriteria
}: TableProps) => (
  <table className={`table${className !== undefined ? " " + className : ""}`}>
    <thead>
      <tr>
        <th className="name">
          <span>Name</span>
        </th>
        <th
          onClick={() => {
            setSortCriteria({
              isAscending:
                sortCriteria.orderFilter === START_DATE
                  ? !sortCriteria.isAscending
                  : true,
              orderFilter: START_DATE
            });
          }}
          className={`whatson-table__sort-option ${
            sortCriteria.orderFilter === START_DATE
              ? `whatson-table__sort-option--${
                  sortCriteria.isAscending ? "active-asc" : "active-desc"
                }`
              : ""
          } date`}
        >
          <span>Date</span>
        </th>
        <th
          onClick={() => {
            setSortCriteria({
              isAscending:
                sortCriteria.orderFilter === HOST_NATION
                  ? !sortCriteria.isAscending
                  : true,
              orderFilter: HOST_NATION
            });
          }}
          className={`whatson-table__sort-option ${
            sortCriteria.orderFilter === HOST_NATION
              ? `whatson-table__sort-option--${
                  sortCriteria.isAscending ? "active-asc" : "active-desc"
                }`
              : ""
          } host nation`}
        >
          <span>Host Nation</span>
        </th>
        <th
          onClick={() => {
            setSortCriteria({
              isAscending:
                sortCriteria.orderFilter === VENUE
                  ? !sortCriteria.isAscending
                  : true,
              orderFilter: VENUE
            });
          }}
          className={`whatson-table__sort-option ${
            sortCriteria.orderFilter === VENUE
              ? `whatson-table__sort-option--${
                  sortCriteria.isAscending ? "active-asc" : "active-desc"
                }`
              : ""
          } location`}
        >
          <span>City/Town</span>
        </th>
        <th className="category">
          <span>{tourCode !== BT ? "Category" : "Grade"}</span>
        </th>
        {tourCode !== JT && tourCode !== VT ? (
          <th
            onClick={() => {
              setSortCriteria({
                isAscending:
                  sortCriteria.orderFilter === PRIZE_MONEY
                    ? !sortCriteria.isAscending
                    : true,
                orderFilter: PRIZE_MONEY
              });
            }}
            className={`whatson-table__sort-option ${
              sortCriteria.orderFilter === PRIZE_MONEY
                ? `whatson-table__sort-option--${
                    sortCriteria.isAscending ? "active-asc" : "active-desc"
                  }`
                : ""
            } prize money`}
          >
            <span>Prize</span>
          </th>
        ) : null}
        <th className="surface">
          <span>Surface</span>
        </th>
        <th className="status">
          <span>Status</span>
        </th>
      </tr>
    </thead>
    <tbody>
      {items !== undefined
        ? items.map((event: TournamentProps, key: number) => (
            <tr
              key={key}
              className={`whatson-table__tournament${
                event.tourStatusCode == "CN" || event.tourStatusCode == "PP"
                  ? "--cancelled"
                  : ""
              }`}
            >
              <td className={`name${event.isRecognised ? " recognised" : ""}`}>
                {event.tourStatusCode !== "CN" &&
                event.tourStatusCode !== "PP" ? (
                  <a href={event.tournamentLink}>
                    <span className="name">
                      <div className="short">
                        {event.tournamentName}
                        {event.isRecognised ? (
                          event.recognisedTournamentLink ? (
                            <a
                              className="recognised-tournament"
                              href={event.recognisedTournamentLink}
                            />
                          ) : (
                            <div className="recognised-tournament" />
                          )
                        ) : null}
                      </div>
                      <div className="long">
                        <span
                          className={`itf-flags itf-flags--${event.hostNationCode}`}
                        />
                        {
                          <div style={{ whiteSpace: "nowrap" }}>
                            {event.tournamentName}{" "}
                            {event.hostNation
                              ? `(${event.hostNationCode})`
                              : ""}
                            {event.isRecognised ? (
                              <a href="#" className="recognised-tournament" />
                            ) : null}
                          </div>
                        }
                      </div>
                    </span>
                  </a>
                ) : (
                  <span className="name">
                    <div className="short">
                      {event.tournamentName}
                      {event.isRecognised ? (
                        <a href="#" className="recognised-tournament" />
                      ) : null}
                    </div>
                    <div className="long">
                      <span
                        className={`itf-flags itf-flags--${event.hostNationCode}`}
                      />
                      {
                        <div style={{ whiteSpace: "nowrap" }}>
                          {event.tournamentName}{" "}
                          {event.hostNation ? `(${event.hostNationCode})` : ""}
                          {event.isRecognised ? (
                            <a href="#" className="recognised-tournament" />
                          ) : null}
                        </div>
                      }
                    </div>
                  </span>
                )}
                {event.tourStatusDesc !== null ? (
                  <Status code={event.tourStatusCode} />
                ) : (event.liveLink && event.liveLink !== "") ||
                  (event.liveStreamingUrl !== "" &&
                    event.liveStreamingUrl !== null) ? (
                  <span className="status">
                    <a
                      target="_blank"
                      href={event.liveStreamingUrl || event.liveLink}
                      className="live"
                    >
                      Live
                    </a>
                  </span>
                ) : null}
              </td>
              <td className="date">
                <span className="label">Date:</span>
                <span className="date">{event.dates}</span>
              </td>
              <td className="hostname">
                <span className="label">Host Nation:</span>
                <span className="hostname">
                  {event.hostNation ? (
                    <div
                      className={`itf-flags itf-flags--${event.hostNationCode}`}
                    />
                  ) : null}
                  {event.hostNation}
                </span>
              </td>
              <td className="location">
                <span className="label">City/Town:</span>
                <span className="location">{event.location}</span>
              </td>
              <td className="category">
                <span className="label">Category:</span>
                <span className="category">{event.category}</span>
              </td>
              {tourCode !== JT && tourCode !== VT ? (
                <td className="prize-money">
                  <span className="label">Prize Money:</span>
                  <span className="prize-money">{event.prizeMoney}</span>
                </td>
              ) : null}
              <td className="surface">
                <span className="label">Surface:</span>
                <span className="surface">
                  {event.indoorOrOutDoor} - {event.surfaceDesc}
                  <div
                    className={`surface-icon__${
                      event.surfaceDesc !== undefined &&
                      event.surfaceDesc !== null
                        ? event.surfaceDesc.toLowerCase()
                        : ""
                    }`}
                  />
                </span>
              </td>
              <td className="status">
                <span className="label">Status:</span>
                {event.tourStatusCode !== null ? (
                  <Status code={event.tourStatusCode} />
                ) : event.liveLink !== "" || event.liveStreamingUrl !== "" ? (
                  <span className="status">
                    {event.liveLink ? (
                      <a target="_blank" href={event.liveLink} className="live">
                        Live
                      </a>
                    ) : null}
                    {event.liveStreamingUrl ? (
                      <a
                        target="_blank"
                        href={event.liveStreamingUrl || event.liveLink}
                        className="live-stream"
                      />
                    ) : null}
                  </span>
                ) : (
                  <span />
                )}
              </td>
            </tr>
          ))
        : null}
    </tbody>
  </table>
);

export default Table;
